export default "__VITE_ASSET__6c983234__"